module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "part1ch2"
    }
  }), _vm._v("Gravlax with Caper Cream Cheese")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_vm._v("My grandfather wasn’t an indulgent man, but there were a handful of things he absolutely loved to eat. The list isn’t very long: fresh scallops, pesto, ripe blueberries, and pumpernickel bread. Even though he’s been gone for quite a few years, I’m still always in search of a good loaf of pumpernickel and I think of him so fondly when I find one (Russ & Daughters on Manhattan’s Lower East Side for the win). My favorite way to enjoy pumpernickel is toasted and spread with a thick schmear of cream cheese and shingled with salty salmon. The "), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("small victory")])]), _vm._v(" here has less to do with the nostalgia of pumpernickel and everything to do with homemade gravlax. Once you realize that a simple combination of sugar, salt, and time can effectively cure fish, not only does serving gravlax become infinitely more affordable but you also gain complete control of the quality of the fish you’re using and the flavors you infuse it with. It’s good to be the one behind the wheel in the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("SERVES 6")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "ingred_sublist1"
  }, [_vm._v("GRAVLAX")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("Packed "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("4")]), _vm._v(" cup [50 g] dark brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" cup [70 g] kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" tsp freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 tsp fennel seeds (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("A handful of fresh sprigs of dill, roughly chopped (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("One 1-lb [455-g] salmon fillet, skin and any pin bones removed")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist1"
  }, [_vm._v("CREAM CHEESE")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("8 oz [230 g] cream cheese, at room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("Grated zest and juice of 1 lemon")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("2 Tbsp capers, roughly chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("2 Tbsp finely chopped fresh chives")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" tsp kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" tsp freshly ground black pepper")])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("12 slices pumpernickel bread, toasted, or 6 pumpernickel bagels, split and toasted")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("A few thinly sliced radishes and/or a sliced cucumber for serving")])]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("TO MAKE THE GRAVLAX:")])]), _vm._v(" In a small bowl, stir together the brown sugar, salt, pepper, fennel seeds (if using), and dill (if using). Use your hands to do this so that you break up any clumps in the sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Put a large piece of plastic wrap on your work surface and put half of the salt mixture on the plastic, spreading it to an even thickness that measures slightly bigger than your piece of salmon. Put the salmon on top of the mixture and cover it with the remaining half of the salt mixture. Use your hands to pack the mixture on and around the fish. Wrap the salmon tightly in the plastic wrap, using an extra piece if needed, but leave the ends open so some air can circulate and the liquid from the fish can drain easily. Put the wrapped salmon on a wire rack set on a small rimmed baking sheet and put another baking sheet on top of the fish. Put something heavy, like a cast-iron pan or a couple of cans of tomatoes, on top of the baking sheet to weigh the whole thing down. (You could use just about anything in place of "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("the baking sheets, such as two large plates, if you don’t have space in your refrigerator for the baking sheets—just be sure whatever is on the bottom has a rim to catch the liquid that escapes from the fish.)")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Put the whole shebang in the refrigerator and let the salmon cure for at least 2 days, for a light cure (the salmon will still be moist), or up to 3 days, for a more intense cure (the salmon will lose quite a bit of moisture). Flip the salmon once a day and drain off whatever liquid accumulates on the baking sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("TO MAKE THE CREAM CHEESE:")])]), _vm._v(" Put the cream cheese, lemon zest, lemon juice, capers, chives, salt, and pepper in a food processor and pulse to combine (alternatively, mix everything in a large bowl using a potato masher or a fork). Keep this mixture at room temperature if you’re serving it immediately. Otherwise, wrap it tightly and refrigerate for up to 1 week; bring the cream cheese back to room temperature before serving so it’s easy to spread.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("When the salmon is cured, unwrap it, thoroughly rinse off the salt mixture, and pat dry with paper towels. Thinly slice the salmon on the diagonal. Spread the cream cheese mixture liberally on the toast and top with the gravlax. Serve topped with thin slices of radish and/or cucumber.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('a', {
    attrs: {
      "id": "pg29sp1"
    }
  }), _c('strong', [_vm._v("SPIN-OFFS")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_c('a', {
    attrs: {
      "id": "pg29lev1"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("FOR CARAWAY GRAVLAX")])]), _vm._v(", substitute 1 tsp caraway seeds for the fennel seeds. Leave the dill in or take it out—up to you.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_c('a', {
    attrs: {
      "id": "pg29lev2"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("FOR PASTRAMI GRAVLAX")])]), _vm._v(", up the black pepper to a full 1 Tbsp and add 1 tsp each coriander seeds and black mustard seeds. Leave out the fennel seeds and dill.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_c('a', {
    attrs: {
      "id": "pg29lev3"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("FOR KOREAN-STYLE GRAVLAX")])]), _vm._v(", add 1 Tbsp gochugaru (Korean red pepper flakes) and 1 tsp toasted sesame seeds. Leave out the black pepper and fennel seeds. Substitute two thinly sliced scallions for the dill.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_c('a', {
    attrs: {
      "id": "pg29lev4"
    }
  }), _vm._v("Skip the fish and make "), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("DRY-BRINED PICKLES")])]), _vm._v(". For carrot-and-dill pickles, thinly slice a whole heap of carrots; toss with salt, sugar, and chopped dill; and refrigerate them, loosely covered with plastic wrap, for a few days. Stir them every so often. Actually, make these at the same time as the gravlax and serve them with the gravlax—yum!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-533db7e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/013-part01chapter02.vue
// module id = 93
// module chunks = 0